import { DeflyWalletConnect } from "@blockshake/defly-connect";
import { DaffiWalletConnect } from "@daffiwallet/connect";
import {
  WalletProvider as TXWalletProvider,
  useInitializeProviders,
  PROVIDER_ID,
  ProvidersArray,
} from "@txnlab/use-wallet";
import { PeraWalletConnect } from "@perawallet/connect";
import LuteConnect from "lute-connect";
import algosdk from "algosdk";
import { algodHost, algodNetwork, algodPort, algodToken } from "@/lib/algo";
import { network } from "@/config";

// @ts-ignore
const providers: ProvidersArray = [];

if (network === "mainnet" || network == "testnet") {
  providers.push({ id: PROVIDER_ID.PERA, clientStatic: PeraWalletConnect });
  providers.push({ id: PROVIDER_ID.DEFLY, clientStatic: DeflyWalletConnect });
}

providers.push({
  id: PROVIDER_ID.LUTE,
  clientStatic: LuteConnect,
  clientOptions: { siteName: "Myth Finance" },
});

if (network === "mainnet" || network == "testnet") {
  providers.push({ id: PROVIDER_ID.DAFFI, clientStatic: DaffiWalletConnect });
}

if (algodNetwork === "localnet") {
  providers.push({
    id: PROVIDER_ID.KMD,
    clientOptions: {
      host: "http://127.0.0.1",
      token: "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
      port: "4002",
      password: "",
      wallet: "DEPLOYER",
    },
  });
  // @ts-ignore ??
  providers.push({ id: PROVIDER_ID.MNEMONIC });
}

export function WalletProvider({ children }: { children: React.ReactChild }) {
  const walletProviders = useInitializeProviders({
    providers,
    nodeConfig: {
      network: algodNetwork,
      nodeServer: algodHost,
      nodePort: algodPort,
      nodeToken: algodToken,
    },
    algosdkStatic: algosdk,
    debug: true,
  });

  return (
    <TXWalletProvider value={walletProviders}>{children}</TXWalletProvider>
  );
}
